import React from 'react';
import Lottie from 'lottie-react';
import Loader from '../../assets/lotties/loader.json';
import './styles.css';

export const ZeusLoader = () => {
  const lottieProps = { animationData: Loader };
  return (
    <div className="loader">
      <Lottie className="zeus-lottie" {...lottieProps} />
    </div>
  );
};